// extracted by mini-css-extract-plugin
export default {"note":"style_note__eIPpZ"};